import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FAQ = () => {
  const faqs = [
    {
      question: 'How do swipe gestures work?',
      answer: "During learning sessions, every card becomes a simple decision: swipe left, right, up, or down to show how well the word was remembered. This helps LinguPix decide what should come back next.",
    },
    {
      question: 'How does smart repetition help my child learn?',
      answer: "Each swipe feeds into our smart repetition system. Instead of random flashcards, vocabulary returns at the exact right moment to build long-term memory, preventing frustration and making practice efficient.",
    },
    {
      question: 'How do I manage child profiles?',
      answer: "Go to Settings > Children. You can set up individual learners with their own names, avatars, and learning preferences. Each child has their own completely separate progress history and goals.",
    },
    {
      question: 'Can I change the learning language or voice?',
      answer: "Yes, you can easily change the target language and pick from a variety of narrator voices to find the best match for your child. Changes apply instantly to their next learning session.",
    },
    {
      question: 'How is my child’s progress tracked?',
      answer: "Parents and educators have access to a dashboard that tracks words mastered, accuracy, completed categories, and practice consistency. You can visibly see their progress grow day by day.",
    },
    {
      question: 'How do rewards and badges work?',
      answer: "Children earn badges, stars, and maintain streaks for consistent practice and mastering new words. These rewards are designed to keep them engaged, motivated, and excited to return for their next session.",
    },
    {
      question: 'How do subscriptions and device limits work?',
      answer: "LinguPix offers plans for families and schools. Depending on your tier, you get a set number of active devices. You can manage which devices are active directly in your Membership settings. All billing is handled securely via the App Store or Google Play.",
    },
    {
      question: 'How do privacy and account deletion work?',
      answer: "Adult-only areas are protected by a Guardian PIN. You can request full account deletion inside the app or via our website, and all data is permanently wiped.",
    },
  ];

  return (
    <section id="faq" className="py-8 sm:py-12 lg:py-16 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-4xl mx-auto">
        {/* Section header */}
        <div className="text-left sm:text-center mb-8 sm:mb-16 space-y-4">
          <div className="inline-block px-4 py-2 bg-[#FFF3E0] rounded-full border border-[#FFE0B2]">
            <span className="text-[#FF7F30] font-semibold text-sm tracking-wide">FAQ</span>
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-[#333333] leading-[1.05] sm:leading-tight lg:leading-[1.1]">
            Questions Before
            <span className="block text-[#FF7F30]">You Choose?</span>
          </h2>
          <p className="text-lg sm:text-xl text-[#666666] max-w-2xl mx-auto leading-relaxed">
            Here are the answers parents, guardians, and educators ask most often before choosing LinguPix.
          </p>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="bg-[#F5F5F5] rounded-2xl px-6 border-none"
            >
              <AccordionTrigger className="text-left text-lg font-semibold text-[#333333] hover:text-[#FF7F30] hover:no-underline transition-colors duration-300 py-6">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-base sm:text-lg text-[#666666] leading-relaxed pb-6">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;